import { Eye } from "@phosphor-icons/react";

/**
 * Small banner shown at the top of company pages when the signed-in
 * sub-account has sub_role="viewer" (read-only). Makes the read-only
 * state feel intentional instead of confusing.
 */
export default function ViewerBanner() {
  return (
    <div
      data-testid="viewer-banner"
      className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 flex items-start gap-3"
    >
      <Eye size={20} className="text-amber-600 shrink-0 mt-0.5" weight="fill" />
      <div className="text-sm">
        <div className="font-semibold text-amber-900">Read-only account</div>
        <div className="text-amber-800/90 mt-0.5">
          You're signed in as a Viewer. You can browse everything the team has
          set up, but you can't create, edit, or delete. Ask an owner to switch
          your role to Manager if you need to make changes.
        </div>
      </div>
    </div>
  );
}
